// extracted by mini-css-extract-plugin
module.exports = {"Book":"Book_Book__j-kOA"};